import Box, { BoxProps } from '@mui/material/Box';
import { PropsWithChildren } from 'react';

type IProps = Pick<BoxProps, 'sx'>;

export const DrawerContent = ({ sx, children }: PropsWithChildren<IProps>) => <Box sx={sx}>{children}</Box>;
